<template>
  <div v-if="paneInfo.loading">Loading...</div>
  <div v-else>
    <sales-table :manager="manager" />
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import SalesTable from './table/SalesTable.vue'
import BaseTasksPane from './BaseTasksPane.vue'

@Component({
  name: 'SalesPane',
  components: {
    SalesTable,
  },
})
export default class SalesPane extends BaseTasksPane {}
</script>
